/* eslint-disable */

import React, { useState } from "react";
import { MobXProviderContext, observer } from "mobx-react";
import Mapa from "./mapa";
import ListaPedidos from "./listaPedidos";
import ListaPedidosFlex from "./listaPedidosFlex";
import ListaEntregadores from "./listaEntregadores";

// Sagres Rotas React components
import Header from "components/Header/Header";

// Sagres Rotas React example components
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function MapaView() {
  const { mapaStore } = React.useContext(MobXProviderContext);
  const [zoom, setZoom] = useState(13);
  const [lat, setLat] = useState(-23.312180);
  const [lng, setLng] = useState(-51.161530);

  let handleMapViewChange = (zoom, lat, lng) => {
    setZoom(zoom);
    setLat(lat);
    setLng(lng);
  }

  // ModoDistribuicao === 1 (flexível) => painel com a feature de Rotas (padrão
  // do app Flutter). Caso contrário => painel clássico, INTOCADO.
  const PainelPedidos = mapaStore.distribuicaoFlexivel
    ? ListaPedidosFlex
    : ListaPedidos;

  return (
    <div className="App" style={{ overflow: 'hidden', }}>
      <Header/>
        <PainelPedidos></PainelPedidos>
        <ListaEntregadores></ListaEntregadores>
        <Mapa
          lat={lat}
          lng={lng}
          onMapViewChange={handleMapViewChange}
          zoom={zoom}
        />
    </div>
  );
}

export default observer(MapaView);
